<template>
  <div>
    <!--摄影订单  -->
    <baseBreadcrumb :page="$t('message.taskToBeFilmed')" :menu="$t('message.photographyServices')" />
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <!-- 待拍摄 -->
          <el-tab-pane :label="$t('message.toBePhotograph')" name="0"></el-tab-pane>
          <!-- 已完成 -->
          <el-tab-pane :label="$t('message.accomplish')" name="1"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">
          {{ $t('message.search') }}
        </el-button>
      </div>
      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="80">
          </el-table-column>
          <!-- 提交时间 -->
          <el-table-column align="center" :label="$t('message.submitTime')" prop="created_at" width="150">
          </el-table-column>
          <!-- 实际完成时间 -->
          <el-table-column align="center" :label="$t('message.actualCompletionTime')" prop="complete_at" width="150"
            v-if="datas.status == 1">
          </el-table-column>
          <!-- 提交人 -->
          <el-table-column align="center" :label="$t('message.submitOne')" prop="created_by_admin.realname" width="100">
          </el-table-column>
          <!-- 订单号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')">
            <template slot-scope="scope">
              <router-link :to="'/orderDetail?order_sn=' + scope.row.order_sn" target="_blank" class="a-link">
                {{ scope.row.order_sn }}</router-link>
            </template>
          </el-table-column>
          <!-- 拍摄数量 -->
          <el-table-column align="center" :label="$t('message.numberOfShotsTaken')" prop="predict_num" width="100">
          </el-table-column>
          <!-- 实际拍摄数量 -->
          <el-table-column align="center" :label="$t('message.actualNumberOfShotsTaken')" prop="complete_num"
            width="150" v-if="datas.status == 1">
          </el-table-column>
          <!-- 摄影文件 -->
          <el-table-column align="center" :label="$t('message.photographFile')">
            <template slot-scope="scope">
              <div class="row" v-for="(item, index) in scope.row.file" :key="index">
                <div class="name">
                  {{ item }}
                </div>
                <div class="download">
                  <a :href="item" target="_blank" rel="noopener noreferrer" class="a-link">下载</a>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 业务备注 -->
          <el-table-column align="center" :label="$t('message.serviceRemarks')" prop="y_remark" width="150">
          </el-table-column>
          <!-- 摄影备注 -->
          <el-table-column align="center" :label="$t('message.photographyNotes')" prop="photo_remark" width="150"
            v-if="datas.status == 1">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="200" v-if="datas.status == 0">
            <template slot-scope="scope">
              <!-- 拍摄完成 -->
              <el-button type="primary" size="small" @click="shootingCompleted(scope.row)" v-if="isAuth(548)">{{
                $t('message.shootingCompleted') }}</el-button>
              <el-button type="primary" class="dark" size="small" @click="deleteJob(scope.row.id)" v-if="isAuth(547)">{{
                $t('message.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 150, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!--拍摄完成-->
    <el-dialog :title="$t('message.shootingCompleted')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="580px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <!-- 订单号 -->
          <el-form-item :label="$t('message.orderNumber')">
            {{ ruleForm.order_sn }}
          </el-form-item>
          <!-- 拍摄数量 -->
          <el-form-item :label="$t('message.actualNumberOfShotsTaken')" prop="complete_num">
            <el-input v-model="ruleForm.complete_num" type="number"></el-input>
          </el-form-item>
          <!-- 摄影备注： -->
          <el-form-item :label="$t('message.photographyNotes')">
            <el-input v-model="ruleForm.photo_remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
          }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="completeJob">{{
          $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        status: '0',
        order_sn: '',
        page: 1,
        pageSize: 100,
      },
      itemData: {},
      total: 0,
      tableData: [],
      show: false,
      // 确认用
      rules: {
        complete_num: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],


      },
      dialogVisible: false,
      ruleForm: {},
    };
  },
  created() {
    this.jobList()
  },
  methods: {
    jobList() {
      this.show = false
      this.$api.photo.jobList(this.datas).then(res => {
        this.show = true
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.jobList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.jobList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.jobList()
    },
    // 摄影确认
    shootingCompleted(row) {
      this.ruleForm = {
        id: row.id,
        complete_num: '',
        photo_remark: '',
        order_sn: row.order_sn,
      }
      this.dialogVisible = true
    },
    // 摄影任务-完成
    completeJob() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.photo.completeJob(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false
            this.jobList()
          });
        }
      })
    },
    //摄影任务-删除
    deleteJob(id) {

      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.photo.deleteJob({ id }).then((res) => {
            this.$message.success(res.msg)
            this.jobList()
          });
        })
        .catch(() => { });
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-bottom: 24px;
  position: relative;

  .item {
    margin-right: 24px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0,
  }
}

.text-left {
  width: 100%;
  text-align: left;


}

.row {
  width: 100%;
  display: flex;

  .name {
    flex: 1
  }

  .download {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>